import {IChangeLanguage, IFooterL10n} from "../interface/IFooter";
import ko from './l10n/ko';
import zh from './l10n/zh';
import ja from './l10n/ja';
import en from './l10n/en';
import th from './l10n/th';
import ru from './l10n/ru';
import id from './l10n/id';
import ar from './l10n/ar';

import de from './l10n/de';
import fr from './l10n/fr';
import it from './l10n/it';
import es_ES from './l10n/es_ES';
import es_MX from './l10n/es_MX';
import pt from './l10n/pt';
import tr from './l10n/tr';

// import zh_Ch from './l10n/zh_Ch';

export const footerL10n: IFooterL10n = {
    ko: ko,
    zh: zh,
    ja: ja,
    en: en,
    th: th,
    ru: ru,
    id: id,
    ar: ar,
    de: de,
    fr: fr,
    it: it,
    es_ES: es_ES,
    es_MX: es_MX,
    pt: pt,
    tr: tr,
};

export const footerL10nLang: IChangeLanguage = {
    ko: "한국어",
    en: "English",
    zh: "中文－繁體",
    ja: "日本語",
    ar: "العربية",
    th: "ภาษาไทย",
    id: "Bahasa Indonesia",
    ru: "Русский",
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
    es_ES: 'Español (ES)',
    es_MX: 'Español (LATAM)',
    pt: 'Português (BR)',
    tr: 'Türkçe',
};
